module.exports = "<span [ngSwitch]=\"_isCompatibilityMode\" *ngIf=\"multiple\">\r\n  <mat-pseudo-checkbox class=\"mat-option-pseudo-checkbox\" *ngSwitchCase=\"true\"\r\n      [state]=\"selected ? 'checked' : ''\" color=\"primary\"></mat-pseudo-checkbox>\r\n  <md-pseudo-checkbox class=\"mat-option-pseudo-checkbox\" *ngSwitchDefault\r\n      [state]=\"selected ? 'checked' : ''\" color=\"primary\"></md-pseudo-checkbox>\r\n</span>\r\n\r\n<ng-content></ng-content>\r\n<div class=\"mat-option-ripple\" *ngIf=\"!disabled\" md-ripple [mdRippleTrigger]=\"_getHostElement()\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_common/_core.md2/option/option.html
// module id = 719
// module chunks = 63